import React from 'react'

import {
    Create,
    SaveButton,
    required,
    Toolbar,
    SimpleForm,
    useTranslate,
} from 'react-admin'
import { Typography, useMediaQuery, useTheme } from '@mui/material';
import styledFormInputs from '../../../ui/inputs/styledFormInputs';
import NavigateBackBtn from '../../../ui/button/NavigateBackBtn';



const validateRequired = [required('Champs obligatoire')]


const notificationSubjectChoices = [{ id: 'button_press', name: 'BUTTON_PRESS' },
 { id: 'button_double_pressed', name: 'BUTTON_DOUBLE_PRESSED' },
 { id: 'button_held', name: 'BUTTON_HELD' },
 { id: 'geofence_crossed', name: 'GEOFENCE_CROSSED' },
 { id: 'battery_low', name: 'BATTERY_LOW' },
 { id: 'battery_status_bad', name: 'BATTERY_STATUS_BAD' },
 { id: 'door_opened', name: 'DOOR_OPENED' },
 { id: 'water_leak_detected', name: 'WATER_LEAK_DETECTED' },
 { id: 'rollover_detected', name: 'ROLLOVER_DETECTED' },
 { id: 'temperature_threshold_reached', name: 'TEMPERATURE_THRESHOLD_REACHED' },
 { id: 'co2_threshold_reached', name: 'CO2_THRESHOLD_REACHED' },
 { id: 'humidity_threshold_reached', name: 'HUMIDITY_THRESHOLD_REACHED' },
 { id: 'address_country_changed', name: 'ADDRESS_COUNTRY_CHANGED' },
 { id: 'address_state_changed', name: 'ADDRESS_STATE_CHANGED' },
 { id: 'address_city_changed', name: 'ADDRESS_CITY_CHANGED' },
 { id: 'high_g_thresholds_reached', name: 'HIGH_G_THRESHOLDS_REACHED' },
 { id: 'motion_detected', name: 'MOTION_DETECTED' },
 { id: 'light_status_from_on_to_off_detected', name: 'LIGHT_STATUS_FROM_ON_TO_OFF_DETECTED' },
 { id: 'light_status_from_off_to_on_detected', name: 'LIGHT_STATUS_FROM_OFF_TO_ON_DETECTED' },
 { id: 'formaldehyde_threshold_reached', name: 'FORMALDEHYDE_THRESHOLD_REACHED' },
 { id: 'fuel_level_threshold_reached', name: 'FUEL_LEVEL_THRESHOLD_REACHED' },
 { id: 'tvoc_threshold_reached', name: 'TVOC_THRESHOLD_REACHED' },
 { id: 'noise_threshold_reached', name: 'NOISE_THRESHOLD_REACHED' },
 { id: 'pm1_threshold_reached', name: 'PM1_THRESHOLD_REACHED' },
 { id: 'pm10_threshold_reached', name: 'PM10_THRESHOLD_REACHED' },
 { id: 'pm2p5_threshold_reached', name: 'PM2P5_THRESHOLD_REACHED' },
 { id: 'presence_detected', name: 'PRESENCE_DETECTED' },
 { id: 'driving_authorization', name: 'DRIVING_AUTHORIZATION' }
]


const ProductCreate = ({ classes, ...props }) => {
    const translate = useTranslate();
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

    const inputsData = [
        { name: 'image', label: translate('resources.products.fields.image'), validate: validateRequired, width: isSmall ? "290px" : "480px", type: "file", accept: "image/png", subLabel: "type: png , max size 200px*200px , max 500KB", maxSize: 500000 },
        { name: 'marketing_name', label: translate('resources.products.fields.marketing_name'), validate: validateRequired, type: "text" },
        { name: 'identifier', label: translate('resources.products.fields.identifier'), validate: validateRequired, type: "text" },
        { name: 'device_type', label: translate('resources.products.fields.device_type'), validate: validateRequired, type: "select", choices: [{ id: 'unb', name: 'UNB' }, { id: 'ibeacon', name: 'IBEACON' }, { id: 'ibutton', name: 'IBUTTON' }] },
        { name: 'operator', label: translate('resources.products.fields.operator'), validate: validateRequired, type: "text" },
        { name: 'sub_identifier', label: translate('resources.products.fields.sub_identifier'), validate: validateRequired, type: "text" },
        { name: 'description', label: translate('resources.products.fields.description'), validate: validateRequired, type: "text" },
        { name: 'version', label: translate('resources.products.fields.version'), validate: validateRequired, type: "text" },
        { name: 'notification_subjects', label: translate('resources.products.fields.notification_subjects'), width: isSmall ? "290px" : "480px", height: "250px", type: "selectArrayInput", choices: notificationSubjectChoices },
    ]






    return (
        <>
            <Typography sx={{ color: theme.palette.text.primary, textAlign: 'start', fontWeight: 700, fontSize: "24px", lineHeight: "42px", margin: "0px 0px 16px 0px" }}>
                <NavigateBackBtn /> {translate('resources.products.create')}
            </Typography>

            <Create
                redirect="list"
                title={'resources.products.create'}
                sx={{
                    "& .MuiPaper-root": {
                        backgroundColor: theme.palette.background.paper,
                        color: theme.palette.text.primary,
                    },
                }}
            >
                <SimpleForm>

                    {styledFormInputs(inputsData)}


                </SimpleForm>
            </Create>
        </>
    )
}

export default ProductCreate





